import { render, staticRenderFns } from "./CadastroTerritorioVegaSemCar.vue?vue&type=template&id=713529fe&scoped=true&lang=pug"
import script from "./CadastroTerritorioVegaSemCar.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioVegaSemCar.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorioVegaSemCar.vue?vue&type=style&index=0&id=713529fe&prod&lang=scss&scoped=true"
import style1 from "./CadastroTerritorioVegaSemCar.vue?vue&type=style&index=1&id=713529fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713529fe",
  null
  
)

export default component.exports